import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instanceaw1sbzrckls9 as RequestHook_instance,
  TransformRequestBodyHook_instance3isql5xg2cuq7 as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance14phngq6mxh8h as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.q5m_1 = key;
        this.r5m_1 = client;
        this.s5m_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.t5m_1 = ArrayList().p2();
        var tmp_0 = this;
        tmp_0.u5m_1 = ClientPluginBuilder$onClose$lambda;
      }
      t5q(block) {
        this.v5m(RequestHook_instance, block);
      }
      m5s(block) {
        this.v5m(TransformRequestBodyHook_instance, block);
      }
      k5p(block) {
        this.v5m(TransformResponseBodyHook_instance, block);
      }
      v5m(hook, handler) {
        this.t5m_1.i2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
